import React from 'react';
import { UilMobileAndroid, UilTablet, UilDesktop } from '@iconscout/react-unicons';
import { useDispatch, useSelector } from 'react-redux';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';
import { Box, Stack, IconButton, Text } from '@chakra-ui/react';
import { toggleMobile } from '../../redux/canvasResolutionSlice';

const y300 = { bg: 'yellow.300', borderColor: 'yellow.300' };
const y400 = { bg: 'yellow.400', borderColor: 'yellow.400' };

const SelectCanvasResolution = () => {
	const toggleValue = useSelector(selectedToggleValue);
	const dispatch = useDispatch();

	function handleChange(value) {
		if (toggleValue === value) return;
		dispatch(toggleMobile(value));
	}
	return (
		<Box ml={5}>
			{/* <Text mt={2} fontFamily={'Inter'} color={'gray.700'} fontWeight='bold' pb={2}>Resolução</Text> */}
			<Stack direction="row">
				<IconButton
					bg={'white'}
					_hover={y300}
					isActive={toggleValue === 1920}
					_active={y400}
					_focus={y400}
					onClick={(e) => {
						handleChange(1920);
					}}
					variant="outline"
					aria-label="Desktop Layout"
					icon={<UilDesktop size={16} />}
				/>
				<IconButton
					bg={'white'}
					_hover={y300}
					isActive={toggleValue === 1024}
					_active={y400}
					_focus={y400}
					onClick={(e) => {
						handleChange(1024);
					}}
					variant="outline"
					ml={1}
					aria-label="Tablet Layout"
					icon={<UilTablet size={16} />}
				/>
				<IconButton
					bg={'white'}
					_hover={y300}
					isActive={toggleValue === 467}
					_active={y400}
					_focus={y400}
					onClick={(e) => {
						handleChange(467);
					}}
					variant="outline"
					ml={1}
					aria-label="Mobile Layout"
					icon={<UilMobileAndroid size={16} />}
				/>
			</Stack>
		</Box>
	);
};

export default SelectCanvasResolution;
